function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { genComponentStyleHook } from "../../_util/genComponentStyleHook";
export var genTypographyStyle = function genTypographyStyle(token) {
  var componentCls = token.componentCls,
    controlHeight = token.controlHeight,
    fontSize = token.fontSize,
    lineHeight = token.lineHeight;
  var marginOffset = (controlHeight - fontSize * lineHeight) / 2;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "span".concat(componentCls), {
    lineHeight: 'inherit',
    color: 'inherit',
    fontSize: 'inherit'
  }), "div".concat(componentCls), {
    lineHeight: 'inherit',
    color: 'inherit',
    fontSize: 'inherit'
  }), "".concat(componentCls), _defineProperty({}, "".concat(componentCls, "-edit"), {
    fontSize: token.fontSize
  })), "".concat(componentCls).concat(componentCls, "-editable-text:not(").concat(componentCls, "-edit-content)"), {
    '&:hover': {
      background: token.colorBgContainer,
      border: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorBorder),
      borderRadius: token.borderRadius,
      position: 'relative',
      insetInlineStart: -token.paddingSM,
      padding: "".concat(marginOffset - token.lineWidth, "px ").concat(token.paddingSM - token.lineWidth, "px")
    },
    'div&:hover': {
      height: token.controlHeight,
      marginTop: -marginOffset,
      marginBottom: "calc(1em - ".concat(marginOffset, "px)")
    },
    'span&:hover': {
      display: 'inline-block',
      height: token.controlHeight,
      marginTop: -marginOffset,
      marginBottom: -marginOffset
    },
    'h1&:hover, h2&:hover, h3&:hover, h4&:hover, h5&:hover': {
      marginTop: "".concat(-marginOffset, "px !important"),
      marginBottom: "".concat(-marginOffset, "px !important")
    }
  }), "".concat(componentCls).concat(componentCls, "-edit-content"), _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-div&"), {
    insetInlineStart: -token.paddingSM,
    marginTop: -marginOffset,
    marginBottom: "calc(1em - ".concat(marginOffset, "px)")
  }), "".concat(componentCls, "-span&"), {
    insetInlineStart: -token.paddingSM,
    marginTop: -marginOffset,
    marginBottom: -marginOffset
  }), "".concat(componentCls, "-h1&, ").concat(componentCls, "-h2&, ").concat(componentCls, "-h3&, ").concat(componentCls, "-h4&, ").concat(componentCls, "-h5&"), {
    insetInlineStart: -token.paddingSM,
    marginTop: "".concat(-marginOffset, "px !important"),
    marginBottom: "".concat(-marginOffset, "px !important")
  }));
};
export default (function (prefixCls) {
  var useStyle = genComponentStyleHook('Typography', function (token) {
    return [genTypographyStyle(token)];
  });
  return useStyle(prefixCls);
});